import React from 'react';
import PropTypes from 'prop-types';

import { Autocomplete } from '@metarouter-private/mr-mui';
import { ACTION_TO_READABLE_ACTION, READABLE_ACTION_TO_ACTION } from 'app/audit-logs/actions';

const ALL_ACTIONS_LABEL = 'All Actions';

export default function ActionSelector({ actions, value, onChange }) {
  const options = [ALL_ACTIONS_LABEL, ...actions.map(action => ACTION_TO_READABLE_ACTION[action])];
  const selectedLabel = value ? ACTION_TO_READABLE_ACTION[value] : ALL_ACTIONS_LABEL;

  const handleChange = (_, label) => {
    onChange(label === ALL_ACTIONS_LABEL ? null : READABLE_ACTION_TO_ACTION[label]);
  };

  return (
    <Autocomplete
      data-test-id="auditLogActionSelector"
      label="Action"
      options={options}
      value={selectedLabel}
      onChange={handleChange}
      disableClearable
    />
  );
}

ActionSelector.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
